import React from 'react'
import { useIsFocused } from 'expo-router'
import { Text, TouchableOpacity, View } from 'react-native'
import { TurnInCardsModal } from '../../../components/cards/TurnInCardsModal'
import { game } from '../../../preview/fixtures/cardBonusOnly'
import { buildActiveGameViewProps } from '../../../preview/buildActiveGameViewProps'
import type { GameState } from '../../../lib/gameState'

const previewState = buildActiveGameViewProps(game).gameState
const state: GameState = {
  ...previewState,
  mustTurnInCards: false,
  cards: { '1': [
    { id: 'tip-1', type: 'infantry', territoryId: previewState.map.territories[0]?.id },
    { id: 'tip-2', type: 'cavalry', territoryId: previewState.map.territories[1]?.id },
    { id: 'tip-3', type: 'artillery', territoryId: previewState.map.territories[2]?.id },
    { id: 'tip-4', type: 'wild' },
  ] },
}

export default function CardTurnInPreview() {
  const focused = useIsFocused()
  const [visible, setVisible] = React.useState(true)
  const [tips, setTips] = React.useState(true)
  return (
    <View className="flex-1 bg-canvas p-4">
      <TouchableOpacity accessibilityRole="button" accessibilityLabel="Open card tip preview"
        onPress={() => { setTips(true); setVisible(true) }}>
        <Text className="text-ink">Open card tip preview</Text>
      </TouchableOpacity>
      <TurnInCardsModal visible={visible && focused} onClose={() => setVisible(false)}
        gameId="preview-card-tip" state={state} myPlayerId="1" canTurnInCards={false}
        tutorialEnabled={tips} onTutorialEnabledChange={setTips} />
    </View>
  )
}
